module.exports = __webpack_public_path__ + "static/media/spacesuit.974a857d.svg";